import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderDropdownAccnt.vue?vue&type=style&index=0&id=baf44ba4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baf44ba4"]])

export default __exports__